import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip
} from "recharts";
import {
  useLazyGetMonthlyGrowthRateQuery,
  useLazyGetFilterQuery,
} from "../../../../services/Api";
import LoaderSpiner from "../../../../components/loaderSpiner";

const filterOptions = [
  { label: "Last 6 Months", value: "last6months" },
  { label: "Last Year", value: "lastyear" },
  { label: "This Month", value: "thismonth" },
  { label: "Month by Month", value: "monthbymonth" },
];

const MonthlyGrowthRate = () => {
  const [selectedRange, setSelectedRange] = useState(30);
  const [selectedFilter, setSelectedFilter] = useState("last6months");

  const [
    triggerRange,
    { data: rangeData, isLoading: rangeLoading, error: rangeError },
  ] = useLazyGetMonthlyGrowthRateQuery();

  const [
    triggerFilter,
    { data: filterData, isLoading: filterLoading, error: filterError },
  ] = useLazyGetFilterQuery();

  useEffect(() => {
    triggerRange({ range: selectedRange });
  }, [triggerRange, selectedRange]);

  useEffect(() => {
    triggerFilter({ filter: selectedFilter });
  }, [triggerFilter, selectedFilter]);

  const transformChartData = (data) => {
    return (
      data?.data?.map((item) => ({
        month: item._id
          ? `${item._id.year}-${String(item._id.month).padStart(2, "0")}`
          : "",
        rate: item.totalProfiles || 0,
      })) || []
    );
  };

  const chartData =
    transformChartData(filterData) || transformChartData(rangeData);

  return (
    <div className="bg-lightgreen p-4 sm:p-6 rounded-2xl min-h-96 w-full max-w-3xl mx-auto h-full">
      <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-4 gap-3 sm:gap-0">
        <h3 className="text-lg font-roboto-mono text-[18px] font-bold self-start sm:self-auto">
          Monthly Growth Rate
        </h3>
        <div className="flex gap-2 flex-wrap justify-center sm:justify-end">
          <select
            className="border border-gray-300 rounded-lg px-2 py-1 text-sm focus:outline-none"
            value={selectedFilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
          >
            {filterOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Centering the chart */}
      <div className="flex justify-center items-center h-80 w-full pt-14">
        {rangeLoading || filterLoading ? (
          <LoaderSpiner />
        ) : rangeError || filterError ? (
          <p className="text-center text-errorcolor">
            Error loading data. Please try again later.
          </p>
        ) : (
          <ResponsiveContainer width="103%" height="125%">
            <LineChart
              data={chartData}
              margin={{ top: 20, right: 5, bottom: 0, left: -40 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#333333" />
              <XAxis
                dataKey="month"
                tick={{ fontSize: 12 }}
                tickLine={false}
                axisLine={{ stroke: "#333333" }}
              />
              <YAxis
                domain={[0, "auto"]}
                tick={{ fontSize: 12 }}
                tickLine={false}
                axisLine={{ stroke: "#333333" }}
              />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="rate"
                stroke="#5D733C"
                strokeWidth={2}
                dot={{ fill: "#5D733C", r: 4 }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default MonthlyGrowthRate;
